export default __webpack_public_path__ + "static/media/bg_xz.073cc4bd.png";